import { render, staticRenderFns } from "./UserProfileCard.vue?vue&type=template&id=3cd7aa7a&scoped=true"
import script from "./UserProfileCard.vue?vue&type=script&lang=js"
export * from "./UserProfileCard.vue?vue&type=script&lang=js"
import style0 from "./UserProfileCard.vue?vue&type=style&index=0&id=3cd7aa7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_cache-loader@4.1.0_webpack@4.47.0__css-load_17791d15a6e6b4923732070da1170b91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd7aa7a",
  null
  
)

export default component.exports